export interface Field {
  id: string;
  type: FieldsItemType;
  required?: boolean;
  multiple?: boolean;
  props: {
    name: string;
    fullWidth: boolean;
    label?: string;
    placeholder?: string;
  };
}

export enum FieldsItemType {
  Input = 'input',
  Select = 'select',
}
